'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _biddingInfo = require('./remote/biddingInfo');

var BiddingInfo = {
    fetchBidderBidding: _biddingInfo.BiddingInfoRemote.fetchBidderBidding,
    fetchCatalogBidding: _biddingInfo.BiddingInfoRemote.fetchCatalogBidding,
    fetchItemBidding: _biddingInfo.BiddingInfoRemote.fetchItemBidding
};

exports.default = BiddingInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/biddingInfo.js
// module id = 1dxa
// module chunks = 60